/*
 * @Author: 丨小小风离丨
 * @Date: 2023-08-28 09:04:17
 * @LastEditTime: 2024-10-23 20:23:47
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\components\file_display\index.js
 * @Description: 
 */
import "./index.scss"


export default function FileDisplay(props) {

    function getFileType(file = '') {
        let arr = file.split('.');
        return arr[arr.length - 1].toLowerCase();
    }
    function deleteFile(e) {
        props.delete();
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
    }

    return (
        <div type={getFileType(props.file)} className={`rsm_file_display ${props.delete?'rsm_file_display_delete_box':''}`}>
            <div className="rsm_file_display_name wjz_ellipsis" title={props.file}>{props.file}</div>
            {props.delete ? (
                <button className="rsm_file_display_delete" onClick={deleteFile}></button>
            ) : (
                <div style={{ display: 'flex', alignItems: 'center', minWidth: 100 }}>
                    <div className="onclik_cls" style={{ marginLeft: 10 }} onClick={props.show} >预览</div>
                    {props?.panel && <div style={{
                        margin: '0 10px',
                        width: 1,
                        height: 10,
                        backgroundColor: '#d9d9d9'
                    }}></div>}
                    <div className="onclik_cls"  onClick={props.download}>下载</div>
                </div>
            )}
        </div>
    )
}